export const SELECTED_PROPERTY_UUID_KEY = 'selectedPropertyUuid';
